import { Config } from "../config/config.js";
import { Helper } from "../util/helper.js";
import React from "react";
import ReactDOM from "react-dom";
export class Dialog extends React.Component<DialogProps, any>{
    private dialog: kendo.ui.Dialog;
    private isOpenPrivate: boolean = false;
    private timer: any = null;
    public rootDiv: HTMLElement;
    private buttonHashes: number[] = [];


    constructor(props: DialogProps) {
        super(props)
        this.rootDiv = document.createElement("div");
        this.setEvents();
    }

    private setEvents = () => {
        //$(document).bind("keyup", this.onKeyUp);
    }

    private generateDialogActions = (): Array<kendo.ui.DialogAction> => {
        this.buttonHashes = [];
        if (Array.isArray(this.props.actions)) {
            return this.props.actions.map((action) => {
                this.buttonHashes.push(Helper.getHashCode(JSON.stringify(action)))
                return { text: action.label, action: action.action, primary: action.primary }
            });
        } else {
            return [];
        }
    }

    private initializeDialog = () => {

        if (this.props.isFlex === true)
            this.rootDiv.style.display = "flex";

        const maxHeight = Helper.hasValue(this.props.maxHeight) ? this.props.maxHeight : "95%";

        this.dialog = $(this.rootDiv).kendoDialog({
            title: this.props.title,
            actions: this.generateDialogActions(),
            visible: false,
            close: (_) => {
                this.isOpenPrivate = false;
                if (this.props.afterClose) {
                    this.props.afterClose();
                }
            },
            width: this.props.width,
            height: this.props.height,
            maxWidth: this.props.maxWidth ?? screen.width,
            maxHeight: maxHeight,
            closable: !this.props.closable ? false : true,
            initOpen: (_) => { },
        }).data("kendoDialog");

        if (Config.settings.isMobileApp) {
            this.dialog.element.on("focusin", () => {
                // In der Mobile App verkleinert die Tastatur die Screen size.
                // Der Dialog muss neu zentriert werden:
                $(window).one("resize", () => this.dialog.center());
            });
        }

        this.props.dialogInternalRef && this.props.dialogInternalRef(this.dialog);

    }

    public open = () => {
        if (this.dialog && !this.isOpenPrivate) {

            const timoeut = this.props.modalCancelTimeout && Helper.hasValue(this.props.modalCancelTimeout) ? this.props.modalCancelTimeout : 0;

            if (!this.timer && timoeut > 0)
                this.timer = setTimeout(() => { this.close(); }, timoeut * 1000)

            this.isOpenPrivate = true;
            this.dialog.open();
        }
    }

    public close = (doCancel: boolean = true) => {
        if (this.dialog && this.isOpenPrivate) {
            this.isOpenPrivate = false;
            this.dialog.close();

            if (doCancel && this.props.modalCancelTimeout && Helper.hasValue(this.props.modalCancelTimeout)) {
                let cancelAction = this.props.actions.find(f => f.cancel);
                if (Helper.hasValue(cancelAction)) {
                    cancelAction.action();
                }
            }
        }
    }

    public isOpen = () => this.isOpenPrivate;

    private onKeyUp = (e: JQuery.KeyUpEvent) => {
        const escape = 27;
        const enter = 13;
        const keyCode = e.keyCode;
        const ctrl = e.ctrlKey;
        if (keyCode === escape) {
            this.close();
        } else if (keyCode === enter) {
            const canCloseDialog = (): boolean => {
                let focused = $(":focus");
                if (focused.length == 0) {
                    return true;
                } else {
                    let classList = focused[0].classList;
                    return (classList.contains("k-content") && classList.contains("k-window-content") && classList.contains("k-dialog-content"));
                }
            }
            if (ctrl && canCloseDialog()) {
                let primaryAction = this.props.actions.find(f => f.primary);
                if (Helper.hasValue(primaryAction)) {
                    let actionResult = primaryAction.action();
                    if (typeof actionResult === "boolean") {
                        if (actionResult) {
                            this.close(false);
                        }
                    } else {
                        this.close(false);
                    }
                }
            }
        }
    }

    componentDidMount() {
        this.initializeDialog();
        if (this.props.open) {
            this.open();
        }
    }

    componentDidUpdate() {
        if (this.props.open != null) {
            if (this.props.open) {
                this.open();
            } else {
                this.close();
            }
        }
        if (!this.areButtonEqual()) {
            this.dialog.setOptions({
                actions: this.generateDialogActions()
            });
        }
        this.dialog.title(this.props.title);
    }

    private areButtonEqual = () => {
        let current = [];
        if (Array.isArray(this.props.actions)) {
            current = this.props.actions.map((action) => {
                return Helper.getHashCode(JSON.stringify(action));
            });
        }
        if (current.length === this.buttonHashes.length) {
            return current.every((element, index) => {
                if (element === this.buttonHashes[index]) {
                    return true;
                }
                return false;
            });
        }
        return false;
    }

    componentWillUnmount() {
        if (this.dialog) {
            this.close(false);
            $(document).unbind("keyup", this.onKeyUp);
            this.dialog.destroy();
        }
        clearTimeout(this.timer);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.rootDiv);
    }
}

export interface DialogProps extends React.PropsWithChildren {
    title: string;
    //onContentRef: (ref: HTMLDivElement) => void;
    actions: Array<DialogAction>;
    afterClose?: () => void;
    width?: number | string;
    height?: number | string;
    maxWidth?: number | string;
    maxHeight?: number | string;
    open?: boolean;
    closable?: boolean;
    modalCancelTimeout?: number;
    dialogInternalRef?: (dialog: kendo.ui.Dialog) => void;
    isFlex?: boolean;
}

export interface DialogAction {
    label: string;
    action: () => void | boolean;
    primary?: boolean;
    cancel?: boolean;
    //modalResult?: boolean;
}